// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.introjs-overlay {
    position: absolute;
    box-sizing: content-box;
    z-index: 999999;
    background-color: rgba(0, 0, 0, 0.336);
    opacity: 0;
    background: -moz-radial-gradient(
        center,
        ellipse farthest-corner,
        rgba(0, 0, 0, 0.4) 0,
        rgba(0, 0, 0, 0.9) 100%
    );
    background: -webkit-gradient(
        radial,
        center center,
        0px,
        center center,
        100%,
        color-stop(0%, rgba(0, 0, 0, 0.4)),
        color-stop(100%, rgba(0, 0, 0, 0.9))
    );
    background: -webkit-radial-gradient(
        center,
        ellipse farthest-corner,
        rgba(0, 0, 0, 0.4) 0,
        rgba(0, 0, 0, 0.9) 100%
    );
    background: -o-radial-gradient(
        center,
        ellipse farthest-corner,
        rgba(0, 0, 0, 0.4) 0,
        rgba(0, 0, 0, 0.9) 100%
    );
    background: -ms-radial-gradient(
        center,
        ellipse farthest-corner,
        rgba(0, 0, 0, 0.4) 0,
        rgba(0, 0, 0, 0.9) 100%
    );
    background: radial-gradient(
        center,
        ellipse farthest-corner,
        rgba(0, 0, 0, 0.4) 0,
        rgba(0, 0, 0, 0.9) 100%
    );
    filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr='#66000000',endColorstr='#e6000000',GradientType=1)";
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
    filter: alpha(opacity=50);
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
}

.introjs-fixParent {
    z-index: 50 !important;
    opacity: 1 !important;
    -webkit-transform: none !important;
    -moz-transform: none !important;
    -ms-transform: none !important;
    -o-transform: none !important;
    transform: none !important;
}

.introjs-showElement,
tr.introjs-showElement > td,
tr.introjs-showElement > th {
    z-index: 9999999 !important;
}

.introjs-disableInteraction {
    z-index: 99999999 !important;
    position: absolute;
    background-color: white;
    opacity: 0;
    filter: alpha(opacity=0);
}

.introjs-relativePosition,
tr.introjs-showElement > td,
tr.introjs-showElement > th {
    position: relative;
}

.introjs-helperLayer {
    box-sizing: content-box;
    position: absolute;
    z-index: 9999998;
    background-color: #fff;
    background-color: rgba(255, 255, 255, 0.9);
    opacity: 0.2;
    -webkit-opacity: 0.2;
    border: 1px solid #777;
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.4);
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
}

.introjs-tooltipReferenceLayer {
    box-sizing: content-box;
    position: absolute;
    visibility: hidden;
    z-index: 100000000;
    background-color: transparent;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
}

.introjs-helperLayer *,
.introjs-helperLayer *:before,
.introjs-helperLayer *:after {
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    -ms-box-sizing: content-box;
    -o-box-sizing: content-box;
    box-sizing: content-box;
}

.introjs-helperNumberLayer {
    box-sizing: content-box;
    position: absolute;
    visibility: hidden;
    top: -16px;
    left: -16px;
    z-index: 9999999999 !important;
    padding: 2px;
    font-family: Arial, verdana, tahoma;
    font-size: 13px;
    font-weight: bold;
    color: white;
    text-align: center;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    background: #ff3019;
    /* Old browsers */
    background: -webkit-linear-gradient(top, #ff3019 0%, #cf0404 100%);
    /* Chrome10+,Safari5.1+ */
    background: -webkit-gradient(
        linear,
        left top,
        left bottom,
        color-stop(0%, #ff3019),
        color-stop(100%, #cf0404)
    );
    /* Chrome,Safari4+ */
    background: -moz-linear-gradient(top, #ff3019 0%, #cf0404 100%);
    /* FF3.6+ */
    background: -ms-linear-gradient(top, #ff3019 0%, #cf0404 100%);
    /* IE10+ */
    background: -o-linear-gradient(top, #ff3019 0%, #cf0404 100%);
    /* Opera 11.10+ */
    background: linear-gradient(to bottom, #ff3019 0%, #cf0404 100%);
    /* W3C */
    width: 20px;
    height: 20px;
    line-height: 20px;
    border: 3px solid white;
    border-radius: 50%;
    filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3019', endColorstr='#cf0404', GradientType=0)";
    /* IE6-9 */
    filter: "progid:DXImageTransform.Microsoft.Shadow(direction=135, strength=2, color=ff0000)";
    /* IE10 text shadows */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
}

.introjs-arrow {
    border: 5px solid transparent;
    content: "";
    position: absolute;
}

.introjs-arrow.top {
    top: -10px;
    border-bottom-color: var(--DarkBlue);
}

.introjs-arrow.top-right {
    top: -10px;
    right: 10px;
    border-bottom-color: var(--DarkBlue);
}

.introjs-arrow.top-middle {
    top: -10px;
    left: 50%;
    margin-left: -5px;
    border-bottom-color: var(--DarkBlue);
}

.introjs-arrow.right {
    right: -10px;
    top: 10px;
    border-left-color: var(--DarkBlue);
}

.introjs-arrow.right-bottom {
    bottom: 10px;
    right: -10px;
    border-left-color: var(--DarkBlue);
}

.introjs-arrow.bottom {
    bottom: -10px;
    border-top-color: var(--DarkBlue);
}

.introjs-arrow.bottom-right {
    bottom: -10px;
    right: 10px;
    border-top-color: var(--DarkBlue);
}

.introjs-arrow.bottom-middle {
    bottom: -10px;
    left: 50%;
    margin-left: -5px;
    border-top-color: var(--DarkBlue);
}

.introjs-arrow.left {
    left: -10px;
    top: 10px;
    border-right-color: var(--DarkBlue);
}

.introjs-arrow.left-bottom {
    left: -10px;
    bottom: 10px;
    border-right-color: var(--DarkBlue);
}

.introjs-tooltip {
    box-sizing: content-box;
    position: absolute;
    visibility: visible;
    padding: 10px;
    background-color: var(--DarkBlue);
    min-width: 200px;
    max-width: 300px;
    border-radius: 3px;
    color: white;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4);
    -webkit-transition: opacity 0.1s ease-out;
    -moz-transition: opacity 0.1s ease-out;
    -ms-transition: opacity 0.1s ease-out;
    -o-transition: opacity 0.1s ease-out;
    transition: opacity 0.1s ease-out;
}

.introjs-tooltipbuttons {
    text-align: right;
    white-space: nowrap;
}

/*
 Buttons style by http://nicolasgallagher.com/lab/css3-github-buttons/
 Changed by Afshin Mehrabani
*/
.introjs-button {
    background-color: var(--BlueButtonComponentBorderColor);
    border: 2px solid var(--BlueButtonComponentBorderColor);
    border-radius: 4px;
    color: white;
    text-transform: uppercase;
    font-family: var(--googleFont);

    box-sizing: content-box;
    position: relative;
    overflow: visible;
    display: inline-block;
    padding: 0.3em 0.8em;

    margin: 0;
    text-decoration: none;

    font-size: 11px;

    white-space: nowrap;
    cursor: pointer;
    outline: none;

    -webkit-background-clip: padding;
    -moz-background-clip: padding;
    -o-background-clip: padding-box;
    /*background-clip: padding-box;*/
    /* commented out due to Opera 11.10 bug */

    /* IE hacks */
    zoom: 1;
    *display: inline;
    margin-top: 10px;
}

.introjs-button:hover {
    border-color: #27272731;
    text-decoration: none;
    box-shadow: 0px 1px 1px #2b2b2b;
}

.introjs-button:focus,
.introjs-button:active {
}

/* overrides extra padding on button elements in Firefox */
.introjs-button::-moz-focus-inner {
    padding: 0;
    border: 0;
}

.introjs-skipbutton {
    box-sizing: content-box;
    margin-right: 5px;
    color: white;

    border: 2px solid var(--DarkBlueButtonBackground);
    background-color: var(--DarkBlueButtonBackground);
}

.introjs-prevbutton {
    background-color: var(--DarkBlueButtonBackground);
    border: 2px solid var(--DarkBlueButtonBackground);
}

.introjs-prevbutton.introjs-fullbutton {
    border: 1px solid #d4d4d4;
    -webkit-border-radius: 0.2em;
    -moz-border-radius: 0.2em;
    border-radius: 0.2em;
}

.introjs-nextbutton {
    /* -webkit-border-radius: 0 0.2em 0.2em 0;
  -moz-border-radius: 0 0.2em 0.2em 0;
  border-radius: 0 0.2em 0.2em 0; */
    background-color: var(--BlueButtonSmallBackground);
}

.introjs-nextbutton.introjs-fullbutton {
    -webkit-border-radius: 0.2em;
    -moz-border-radius: 0.2em;
    border-radius: 0.2em;
}

.introjs-disabled,
.introjs-disabled:hover,
.introjs-disabled:focus {
    display: none;
    opacity: 0.2;
    box-shadow: none;
    cursor: default;
}

.introjs-hidden {
    display: none;
}

.introjs-bullets {
    text-align: center;
}

.introjs-bullets ul {
    box-sizing: content-box;
    clear: both;
    margin: 15px auto 0;
    padding: 0;
    display: inline-block;
}

.introjs-bullets ul li {
    box-sizing: content-box;
    list-style: none;
    float: left;
    margin: 0 2px;
}

.introjs-bullets ul li a {
    box-sizing: content-box;
    display: block;
    width: 6px;
    height: 6px;
    background: #ccc;
    border-radius: 10px;
    -moz-border-radius: 10px;
    -webkit-border-radius: 10px;
    text-decoration: none;
    cursor: pointer;
}

.introjs-bullets ul li a:hover {
    background: #999;
}

.introjs-bullets ul li a.active {
    background: #999;
}

.introjs-progress {
    box-sizing: content-box;
    overflow: hidden;
    height: 10px;
    margin: 10px 0 5px 0;
    border-radius: 4px;
    background-color: #ecf0f1;
}

.introjs-progressbar {
    box-sizing: content-box;
    float: left;
    width: 0%;
    height: 100%;
    font-size: 10px;
    line-height: 10px;
    text-align: center;
    background-color: #08c;
}

.introjsFloatingElement {
    position: absolute;
    height: 0;
    width: 0;
    left: 50%;
    top: 50%;
}

.introjs-fixedTooltip {
    position: fixed;
}

.introjs-hint {
    box-sizing: content-box;
    position: absolute;
    background: transparent;
    width: 20px;
    height: 15px;
    cursor: pointer;
}

.introjs-hint:focus {
    border: 0;
    outline: 0;
}

.introjs-hidehint {
    display: none;
}

.introjs-fixedhint {
    position: fixed;
}

.introjs-hint:hover > .introjs-hint-pulse {
    border: 5px solid rgba(60, 60, 60, 0.57);
}

.introjs-hint-pulse {
    box-sizing: content-box;
    width: 10px;
    height: 10px;
    border: 5px solid rgba(60, 60, 60, 0.27);
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    background-color: rgba(136, 136, 136, 0.24);
    z-index: 10;
    position: absolute;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -ms-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
}

.introjs-hint-no-anim .introjs-hint-dot {
    -webkit-animation: none;
    -moz-animation: none;
    animation: none;
}

.introjs-hint-dot {
    box-sizing: content-box;
    border: 10px solid rgba(146, 146, 146, 0.36);
    background: transparent;
    -webkit-border-radius: 60px;
    -moz-border-radius: 60px;
    border-radius: 60px;
    height: 50px;
    width: 50px;
    -webkit-animation: introjspulse 3s ease-out;
    -moz-animation: introjspulse 3s ease-out;
    animation: introjspulse 3s ease-out;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    position: absolute;
    top: -25px;
    left: -25px;
    z-index: 1;
    opacity: 0;
}

@-webkit-keyframes introjspulse {
    0% {
        -webkit-transform: scale(0);
        opacity: 0;
    }

    25% {
        -webkit-transform: scale(0);
        opacity: 0.1;
    }

    50% {
        -webkit-transform: scale(0.1);
        opacity: 0.3;
    }

    75% {
        -webkit-transform: scale(0.5);
        opacity: 0.5;
    }

    100% {
        -webkit-transform: scale(1);
        opacity: 0;
    }
}

@-moz-keyframes introjspulse {
    0% {
        -moz-transform: scale(0);
        opacity: 0;
    }

    25% {
        -moz-transform: scale(0);
        opacity: 0.1;
    }

    50% {
        -moz-transform: scale(0.1);
        opacity: 0.3;
    }

    75% {
        -moz-transform: scale(0.5);
        opacity: 0.5;
    }

    100% {
        -moz-transform: scale(1);
        opacity: 0;
    }
}

@keyframes introjspulse {
    0% {
        transform: scale(0);
        opacity: 0;
    }

    25% {
        transform: scale(0);
        opacity: 0.1;
    }

    50% {
        transform: scale(0.1);
        opacity: 0.3;
    }

    75% {
        transform: scale(0.5);
        opacity: 0.5;
    }

    100% {
        transform: scale(1);
        opacity: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/style/introjs.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,sCAAsC;IACtC,UAAU;IACV;;;;;KAKC;IACD;;;;;;;;KAQC;IACD;;;;;KAKC;IACD;;;;;KAKC;IACD;;;;;KAKC;IACD;;;;;KAKC;IACD,sHAAsH;IACtH,iEAAiE;IACjE,yBAAyB;IACzB,qCAAqC;IACrC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;;;IAGI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,0CAA0C;IAC1C,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;IAClB,yCAAyC;IACzC,qCAAqC;IACrC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,qCAAqC;IACrC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;;;IAGI,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,mCAAmC;IACnC,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,iBAAiB;IACjB,kEAAkE;IAClE,yBAAyB;IACzB;;;;;;KAMC;IACD,oBAAoB;IACpB,+DAA+D;IAC/D,WAAW;IACX,8DAA8D;IAC9D,UAAU;IACV,6DAA6D;IAC7D,iBAAiB;IACjB,gEAAgE;IAChE,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,oHAAoH;IACpH,UAAU;IACV,2FAA2F;IAC3F,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,SAAS;IACT,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;;CAGC;AACD;IACI,uDAAuD;IACvD,uDAAuD;IACvD,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,8BAA8B;;IAE9B,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,oBAAoB;;IAEpB,SAAS;IACT,qBAAqB;;IAErB,eAAe;;IAEf,mBAAmB;IACnB,eAAe;IACf,aAAa;;IAEb,gCAAgC;IAChC,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;IAChC,yCAAyC;;IAEzC,aAAa;IACb,OAAO;KACP,eAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;;AAEA;;AAEA,0DAA0D;AAC1D;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;;IAEZ,iDAAiD;IACjD,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;IACjD,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI;;mCAE+B;IAC/B,kDAAkD;AACtD;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;;;IAGI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,2BAA2B;IAC3B,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,4CAA4C;IAC5C,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,2CAA2C;IAC3C,wCAAwC;IACxC,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,mCAAmC;IACnC,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,UAAU;AACd;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,2BAA2B;QAC3B,YAAY;IAChB;;IAEA;QACI,6BAA6B;QAC7B,YAAY;IAChB;;IAEA;QACI,6BAA6B;QAC7B,YAAY;IAChB;;IAEA;QACI,2BAA2B;QAC3B,UAAU;IACd;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,YAAY;IAChB;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ","sourcesContent":[".introjs-overlay {\n    position: absolute;\n    box-sizing: content-box;\n    z-index: 999999;\n    background-color: rgba(0, 0, 0, 0.336);\n    opacity: 0;\n    background: -moz-radial-gradient(\n        center,\n        ellipse farthest-corner,\n        rgba(0, 0, 0, 0.4) 0,\n        rgba(0, 0, 0, 0.9) 100%\n    );\n    background: -webkit-gradient(\n        radial,\n        center center,\n        0px,\n        center center,\n        100%,\n        color-stop(0%, rgba(0, 0, 0, 0.4)),\n        color-stop(100%, rgba(0, 0, 0, 0.9))\n    );\n    background: -webkit-radial-gradient(\n        center,\n        ellipse farthest-corner,\n        rgba(0, 0, 0, 0.4) 0,\n        rgba(0, 0, 0, 0.9) 100%\n    );\n    background: -o-radial-gradient(\n        center,\n        ellipse farthest-corner,\n        rgba(0, 0, 0, 0.4) 0,\n        rgba(0, 0, 0, 0.9) 100%\n    );\n    background: -ms-radial-gradient(\n        center,\n        ellipse farthest-corner,\n        rgba(0, 0, 0, 0.4) 0,\n        rgba(0, 0, 0, 0.9) 100%\n    );\n    background: radial-gradient(\n        center,\n        ellipse farthest-corner,\n        rgba(0, 0, 0, 0.4) 0,\n        rgba(0, 0, 0, 0.9) 100%\n    );\n    filter: \"progid:DXImageTransform.Microsoft.gradient(startColorstr='#66000000',endColorstr='#e6000000',GradientType=1)\";\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";\n    filter: alpha(opacity=50);\n    -webkit-transition: all 0.3s ease-out;\n    -moz-transition: all 0.3s ease-out;\n    -ms-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n.introjs-fixParent {\n    z-index: 50 !important;\n    opacity: 1 !important;\n    -webkit-transform: none !important;\n    -moz-transform: none !important;\n    -ms-transform: none !important;\n    -o-transform: none !important;\n    transform: none !important;\n}\n\n.introjs-showElement,\ntr.introjs-showElement > td,\ntr.introjs-showElement > th {\n    z-index: 9999999 !important;\n}\n\n.introjs-disableInteraction {\n    z-index: 99999999 !important;\n    position: absolute;\n    background-color: white;\n    opacity: 0;\n    filter: alpha(opacity=0);\n}\n\n.introjs-relativePosition,\ntr.introjs-showElement > td,\ntr.introjs-showElement > th {\n    position: relative;\n}\n\n.introjs-helperLayer {\n    box-sizing: content-box;\n    position: absolute;\n    z-index: 9999998;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, 0.9);\n    opacity: 0.2;\n    -webkit-opacity: 0.2;\n    border: 1px solid #777;\n    border: 1px solid rgba(0, 0, 0, 0.5);\n    border-radius: 4px;\n    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.4);\n    -webkit-transition: all 0.3s ease-out;\n    -moz-transition: all 0.3s ease-out;\n    -ms-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n.introjs-tooltipReferenceLayer {\n    box-sizing: content-box;\n    position: absolute;\n    visibility: hidden;\n    z-index: 100000000;\n    background-color: transparent;\n    -webkit-transition: all 0.3s ease-out;\n    -moz-transition: all 0.3s ease-out;\n    -ms-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n.introjs-helperLayer *,\n.introjs-helperLayer *:before,\n.introjs-helperLayer *:after {\n    -webkit-box-sizing: content-box;\n    -moz-box-sizing: content-box;\n    -ms-box-sizing: content-box;\n    -o-box-sizing: content-box;\n    box-sizing: content-box;\n}\n\n.introjs-helperNumberLayer {\n    box-sizing: content-box;\n    position: absolute;\n    visibility: hidden;\n    top: -16px;\n    left: -16px;\n    z-index: 9999999999 !important;\n    padding: 2px;\n    font-family: Arial, verdana, tahoma;\n    font-size: 13px;\n    font-weight: bold;\n    color: white;\n    text-align: center;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);\n    background: #ff3019;\n    /* Old browsers */\n    background: -webkit-linear-gradient(top, #ff3019 0%, #cf0404 100%);\n    /* Chrome10+,Safari5.1+ */\n    background: -webkit-gradient(\n        linear,\n        left top,\n        left bottom,\n        color-stop(0%, #ff3019),\n        color-stop(100%, #cf0404)\n    );\n    /* Chrome,Safari4+ */\n    background: -moz-linear-gradient(top, #ff3019 0%, #cf0404 100%);\n    /* FF3.6+ */\n    background: -ms-linear-gradient(top, #ff3019 0%, #cf0404 100%);\n    /* IE10+ */\n    background: -o-linear-gradient(top, #ff3019 0%, #cf0404 100%);\n    /* Opera 11.10+ */\n    background: linear-gradient(to bottom, #ff3019 0%, #cf0404 100%);\n    /* W3C */\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    border: 3px solid white;\n    border-radius: 50%;\n    filter: \"progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3019', endColorstr='#cf0404', GradientType=0)\";\n    /* IE6-9 */\n    filter: \"progid:DXImageTransform.Microsoft.Shadow(direction=135, strength=2, color=ff0000)\";\n    /* IE10 text shadows */\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);\n}\n\n.introjs-arrow {\n    border: 5px solid transparent;\n    content: \"\";\n    position: absolute;\n}\n\n.introjs-arrow.top {\n    top: -10px;\n    border-bottom-color: var(--DarkBlue);\n}\n\n.introjs-arrow.top-right {\n    top: -10px;\n    right: 10px;\n    border-bottom-color: var(--DarkBlue);\n}\n\n.introjs-arrow.top-middle {\n    top: -10px;\n    left: 50%;\n    margin-left: -5px;\n    border-bottom-color: var(--DarkBlue);\n}\n\n.introjs-arrow.right {\n    right: -10px;\n    top: 10px;\n    border-left-color: var(--DarkBlue);\n}\n\n.introjs-arrow.right-bottom {\n    bottom: 10px;\n    right: -10px;\n    border-left-color: var(--DarkBlue);\n}\n\n.introjs-arrow.bottom {\n    bottom: -10px;\n    border-top-color: var(--DarkBlue);\n}\n\n.introjs-arrow.bottom-right {\n    bottom: -10px;\n    right: 10px;\n    border-top-color: var(--DarkBlue);\n}\n\n.introjs-arrow.bottom-middle {\n    bottom: -10px;\n    left: 50%;\n    margin-left: -5px;\n    border-top-color: var(--DarkBlue);\n}\n\n.introjs-arrow.left {\n    left: -10px;\n    top: 10px;\n    border-right-color: var(--DarkBlue);\n}\n\n.introjs-arrow.left-bottom {\n    left: -10px;\n    bottom: 10px;\n    border-right-color: var(--DarkBlue);\n}\n\n.introjs-tooltip {\n    box-sizing: content-box;\n    position: absolute;\n    visibility: visible;\n    padding: 10px;\n    background-color: var(--DarkBlue);\n    min-width: 200px;\n    max-width: 300px;\n    border-radius: 3px;\n    color: white;\n    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4);\n    -webkit-transition: opacity 0.1s ease-out;\n    -moz-transition: opacity 0.1s ease-out;\n    -ms-transition: opacity 0.1s ease-out;\n    -o-transition: opacity 0.1s ease-out;\n    transition: opacity 0.1s ease-out;\n}\n\n.introjs-tooltipbuttons {\n    text-align: right;\n    white-space: nowrap;\n}\n\n/*\n Buttons style by http://nicolasgallagher.com/lab/css3-github-buttons/\n Changed by Afshin Mehrabani\n*/\n.introjs-button {\n    background-color: var(--BlueButtonComponentBorderColor);\n    border: 2px solid var(--BlueButtonComponentBorderColor);\n    border-radius: 4px;\n    color: white;\n    text-transform: uppercase;\n    font-family: var(--googleFont);\n\n    box-sizing: content-box;\n    position: relative;\n    overflow: visible;\n    display: inline-block;\n    padding: 0.3em 0.8em;\n\n    margin: 0;\n    text-decoration: none;\n\n    font-size: 11px;\n\n    white-space: nowrap;\n    cursor: pointer;\n    outline: none;\n\n    -webkit-background-clip: padding;\n    -moz-background-clip: padding;\n    -o-background-clip: padding-box;\n    /*background-clip: padding-box;*/\n    /* commented out due to Opera 11.10 bug */\n\n    /* IE hacks */\n    zoom: 1;\n    *display: inline;\n    margin-top: 10px;\n}\n\n.introjs-button:hover {\n    border-color: #27272731;\n    text-decoration: none;\n    box-shadow: 0px 1px 1px #2b2b2b;\n}\n\n.introjs-button:focus,\n.introjs-button:active {\n}\n\n/* overrides extra padding on button elements in Firefox */\n.introjs-button::-moz-focus-inner {\n    padding: 0;\n    border: 0;\n}\n\n.introjs-skipbutton {\n    box-sizing: content-box;\n    margin-right: 5px;\n    color: white;\n\n    border: 2px solid var(--DarkBlueButtonBackground);\n    background-color: var(--DarkBlueButtonBackground);\n}\n\n.introjs-prevbutton {\n    background-color: var(--DarkBlueButtonBackground);\n    border: 2px solid var(--DarkBlueButtonBackground);\n}\n\n.introjs-prevbutton.introjs-fullbutton {\n    border: 1px solid #d4d4d4;\n    -webkit-border-radius: 0.2em;\n    -moz-border-radius: 0.2em;\n    border-radius: 0.2em;\n}\n\n.introjs-nextbutton {\n    /* -webkit-border-radius: 0 0.2em 0.2em 0;\n  -moz-border-radius: 0 0.2em 0.2em 0;\n  border-radius: 0 0.2em 0.2em 0; */\n    background-color: var(--BlueButtonSmallBackground);\n}\n\n.introjs-nextbutton.introjs-fullbutton {\n    -webkit-border-radius: 0.2em;\n    -moz-border-radius: 0.2em;\n    border-radius: 0.2em;\n}\n\n.introjs-disabled,\n.introjs-disabled:hover,\n.introjs-disabled:focus {\n    display: none;\n    opacity: 0.2;\n    box-shadow: none;\n    cursor: default;\n}\n\n.introjs-hidden {\n    display: none;\n}\n\n.introjs-bullets {\n    text-align: center;\n}\n\n.introjs-bullets ul {\n    box-sizing: content-box;\n    clear: both;\n    margin: 15px auto 0;\n    padding: 0;\n    display: inline-block;\n}\n\n.introjs-bullets ul li {\n    box-sizing: content-box;\n    list-style: none;\n    float: left;\n    margin: 0 2px;\n}\n\n.introjs-bullets ul li a {\n    box-sizing: content-box;\n    display: block;\n    width: 6px;\n    height: 6px;\n    background: #ccc;\n    border-radius: 10px;\n    -moz-border-radius: 10px;\n    -webkit-border-radius: 10px;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.introjs-bullets ul li a:hover {\n    background: #999;\n}\n\n.introjs-bullets ul li a.active {\n    background: #999;\n}\n\n.introjs-progress {\n    box-sizing: content-box;\n    overflow: hidden;\n    height: 10px;\n    margin: 10px 0 5px 0;\n    border-radius: 4px;\n    background-color: #ecf0f1;\n}\n\n.introjs-progressbar {\n    box-sizing: content-box;\n    float: left;\n    width: 0%;\n    height: 100%;\n    font-size: 10px;\n    line-height: 10px;\n    text-align: center;\n    background-color: #08c;\n}\n\n.introjsFloatingElement {\n    position: absolute;\n    height: 0;\n    width: 0;\n    left: 50%;\n    top: 50%;\n}\n\n.introjs-fixedTooltip {\n    position: fixed;\n}\n\n.introjs-hint {\n    box-sizing: content-box;\n    position: absolute;\n    background: transparent;\n    width: 20px;\n    height: 15px;\n    cursor: pointer;\n}\n\n.introjs-hint:focus {\n    border: 0;\n    outline: 0;\n}\n\n.introjs-hidehint {\n    display: none;\n}\n\n.introjs-fixedhint {\n    position: fixed;\n}\n\n.introjs-hint:hover > .introjs-hint-pulse {\n    border: 5px solid rgba(60, 60, 60, 0.57);\n}\n\n.introjs-hint-pulse {\n    box-sizing: content-box;\n    width: 10px;\n    height: 10px;\n    border: 5px solid rgba(60, 60, 60, 0.27);\n    -webkit-border-radius: 30px;\n    -moz-border-radius: 30px;\n    border-radius: 30px;\n    background-color: rgba(136, 136, 136, 0.24);\n    z-index: 10;\n    position: absolute;\n    -webkit-transition: all 0.2s ease-out;\n    -moz-transition: all 0.2s ease-out;\n    -ms-transition: all 0.2s ease-out;\n    -o-transition: all 0.2s ease-out;\n    transition: all 0.2s ease-out;\n}\n\n.introjs-hint-no-anim .introjs-hint-dot {\n    -webkit-animation: none;\n    -moz-animation: none;\n    animation: none;\n}\n\n.introjs-hint-dot {\n    box-sizing: content-box;\n    border: 10px solid rgba(146, 146, 146, 0.36);\n    background: transparent;\n    -webkit-border-radius: 60px;\n    -moz-border-radius: 60px;\n    border-radius: 60px;\n    height: 50px;\n    width: 50px;\n    -webkit-animation: introjspulse 3s ease-out;\n    -moz-animation: introjspulse 3s ease-out;\n    animation: introjspulse 3s ease-out;\n    -webkit-animation-iteration-count: infinite;\n    -moz-animation-iteration-count: infinite;\n    animation-iteration-count: infinite;\n    position: absolute;\n    top: -25px;\n    left: -25px;\n    z-index: 1;\n    opacity: 0;\n}\n\n@-webkit-keyframes introjspulse {\n    0% {\n        -webkit-transform: scale(0);\n        opacity: 0;\n    }\n\n    25% {\n        -webkit-transform: scale(0);\n        opacity: 0.1;\n    }\n\n    50% {\n        -webkit-transform: scale(0.1);\n        opacity: 0.3;\n    }\n\n    75% {\n        -webkit-transform: scale(0.5);\n        opacity: 0.5;\n    }\n\n    100% {\n        -webkit-transform: scale(1);\n        opacity: 0;\n    }\n}\n\n@-moz-keyframes introjspulse {\n    0% {\n        -moz-transform: scale(0);\n        opacity: 0;\n    }\n\n    25% {\n        -moz-transform: scale(0);\n        opacity: 0.1;\n    }\n\n    50% {\n        -moz-transform: scale(0.1);\n        opacity: 0.3;\n    }\n\n    75% {\n        -moz-transform: scale(0.5);\n        opacity: 0.5;\n    }\n\n    100% {\n        -moz-transform: scale(1);\n        opacity: 0;\n    }\n}\n\n@keyframes introjspulse {\n    0% {\n        transform: scale(0);\n        opacity: 0;\n    }\n\n    25% {\n        transform: scale(0);\n        opacity: 0.1;\n    }\n\n    50% {\n        transform: scale(0.1);\n        opacity: 0.3;\n    }\n\n    75% {\n        transform: scale(0.5);\n        opacity: 0.5;\n    }\n\n    100% {\n        transform: scale(1);\n        opacity: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
